import styles from './Contacts.module.css';
import { LandingSectionTitle } from '@features/landing/shared/ui/components/LandingSectionTitle';
import { LandingButton } from '@features/landing/shared/ui/components/LandingButton';
import { TelegramIcon } from '@features/landing/shared/ui/icons/TelegramIcon';
import { LandingLink } from '@features/landing/shared/ui/components/LandingLink/LandingLink';
import { ReactNode } from 'react';

export type ContactsProps = {
  telegramChannels: {
    href: string;
    label: ReactNode;
  }[];
};

export function Contacts({ telegramChannels }: ContactsProps) {
  return (
    <>
      <LandingSectionTitle>Связь с организаторами</LandingSectionTitle>

      <div className={styles.actions}>
        {telegramChannels.map((c, idx) => (
          <LandingButton
            key={idx}
            href={c.href}
            className={styles.action}
            size="22m-52"
          >
            <TelegramIcon className={styles.actionIcon} />
            {c.label}
          </LandingButton>
        ))}
      </div>

      <div className={styles.contacts}>
        <div className={styles.contact}>
          Присоединяйтесь к чатам турниров, чтобы быстро получать ответы на
          вопросы и быть в курсе новостей.
        </div>
        <div className={styles.contact}>
          Дополнительные способы связи
          <br />
          <div className={styles.contactsGrid}>
            <span>Телефон:</span>{' '}
            <LandingLink href="tel:+7495-118-23-06">
              +7 495 118 23 06
            </LandingLink>
            <span>Эл. почта:</span>{' '}
            <LandingLink href="mailto:turnir@chessrussian.ru">
              turnir@chessrussian.ru
            </LandingLink>
          </div>
        </div>
      </div>
    </>
  );
}
